import { Cross1Icon, PersonIcon } from "@radix-ui/react-icons";
import { useQuery } from "@tanstack/react-query";

import { Avatar } from "@/components/ui/avatar";
import { SimpleTooltip } from "@/components/ui/tooltip";
import { getHydratedUserDidQueryOptions } from "@/lib/api";

export function UserAvatar({ did }: { did: string }) {
  const { data: user } = useQuery(getHydratedUserDidQueryOptions(did));

  const avatar = (
    <Avatar
      src={user?.avatar}
      alt={user?.avatar || ""}
      fallback={user ? <PersonIcon /> : <Cross1Icon />}
      variant={user ? "default" : "error"}
    />
  );

  return user ? (
    <SimpleTooltip
      side="left"
      message={
        <div>
          <div>{user.display_name || user.handle}</div>
          <div className="text-xs text-slate-dim">@{user.handle}</div>
          <div className="text-[10px] text-slate-dim">{user.did}</div>
        </div>
      }
    >
      {avatar}
    </SimpleTooltip>
  ) : (
    <SimpleTooltip side="left" message="User not found">
      {avatar}
    </SimpleTooltip>
  );
}
